import React from "react";
import Header from "../common/header";
import ITcareerHead from "../layout/it career/itcareer-head";
import ITcareerContent from "../layout/it career/itcareer-content";
import Footer from "../common/footer";


function ITcareer() {
    return (
        <div>
            <Header />
            <br />
            <ITcareerHead />
            <br />
            <ITcareerContent />
            <br />
            <Footer />
        </div>
    );
}

export default ITcareer;